module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "common_save_btn",
    class: _vm.addButtonClass
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'wasteCollectionAreaCreate',
        params: {
          _id: '0'
        }
      }
    }
  }, [_c('button', {
    staticClass: "btn gradientbt"
  }, [_vm._v("+ Add Zone")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "main_select_wrp_relative main_select_wrp_vechile"
  }, [_c('div', {
    staticClass: "modal fade model_modify_wrp",
    attrs: {
      "id": "filtertoogle",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h2', [_vm._v("Filters")]), _vm._v(" "), _c('button', {
    staticClass: "close clearButton",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Clear\n              All")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "main_select_wrp"
  }, [_c('div', {
    staticClass: "flex selectwca_wrp"
  }, [_c('div', {
    staticClass: "multiselected"
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('multiselect', {
    key: _vm.status.length,
    attrs: {
      "track-by": "value",
      "label": "name",
      "placeholder": "Select Status",
      "options": _vm.status,
      "name": "status",
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": ""
    },
    on: {
      "select": _vm.onSelectStatus,
      "remove": _vm.onRemoveStatus
    },
    model: {
      value: (_vm.clearFilters.status.value),
      callback: function($$v) {
        _vm.$set(_vm.clearFilters.status, "value", $$v)
      },
      expression: "clearFilters.status.value"
    }
  })], 1)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "datedrop_boxs_wrapper"
  }, [_c('div', {
    staticClass: "datedrop_boxs_inner datedrop_boxs_inner_survey"
  }, [_c('div', {
    class: _vm.addButtonClass
  }, [_c('div', {
    staticClass: "filter_wrpp filter_wrpp1"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#filtertoogle"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/pri_filter_icon.png")
    }
  }), _vm._v("\n                  Apply Filter\n                  "), _c('span', {
    class: {
      'counter_filter': _vm.count
    }
  }, [_vm._v(_vm._s(_vm.count))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('v-server-table', {
    ref: "wasteCollectionAreaCreateTable",
    staticClass: "table_wrp",
    attrs: {
      "url": "",
      "limit": 5,
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "loaded": _vm.onLoaded
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function(props) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between collection_division_wrp collection_division_width"
        }, [_c('a', {
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.action(props.row)
            }
          }
        }, [_vm._v("\n              Collection Division\n            ")]), _vm._v(" "), _c('div', {
          staticClass: "py-2 text-center row"
        }, [_c('label', {
          staticClass: "toggle"
        }, [_c('input', {
          staticClass: "toggle-checkbox",
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": props.row.status
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return (function (e) { return _vm.activateWasteModal(props.row); }).apply(null, arguments)
            }
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "slider"
        })])])])]
      }
    }])
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-066a746c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/wasteCollectionArea/wasteCollectionArea.vue
// module id = 2260
// module chunks = 1